import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Loader } from '../Loader';
import { DocumentImportStatusTable } from '.';
import { CardErrorMessage } from '..';

/**
 * For rendering multiple DocumentTemplateSectionRow on the same page, documentType can be used as a string that is the
 * key in the key-value pair of the form to be uploaded. E.g.:
 * {
 *     'documentType': userSelectedFile
 * }
 * @param {*} param0 
 * @returns 
 */
const DocumentTemplateSectionRow = _ref => {
  let {
    title,
    template,
    documentType,
    loading,
    onUpload,
    onDelete,
    accountType = 'admin',
    importStatuses = [],
    uploadButtonText = null,
    downloadButtonText = null
  } = _ref;
  const {
    t
  } = useTranslation();
  uploadButtonText ||= t('upload_template');
  downloadButtonText ||= t('download_template');
  console.log('Import statuses', importStatuses);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement("h5", null, title))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12,
    className: "d-flex justify-content-center"
  }, accountType !== 'customer' && /*#__PURE__*/React.createElement("label", {
    className: "btn btn-info btn-md me-2"
  }, loading ? /*#__PURE__*/React.createElement(Loader, null) : uploadButtonText, /*#__PURE__*/React.createElement("input", {
    style: {
      display: 'none'
    },
    type: "file",
    onChange: e => onUpload(e, documentType)
  })), template && /*#__PURE__*/React.createElement("a", {
    href: template.download_link.url,
    download: `${title}.docx`,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("label", {
    className: "btn btn-info btn-md"
  }, downloadButtonText)))), /*#__PURE__*/React.createElement(Row, null, importStatuses.length ? /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(DocumentImportStatusTable, {
    importStatuses: importStatuses,
    onDelete: onDelete
  })) : /*#__PURE__*/React.createElement(CardErrorMessage, {
    errorMessage: t('no_documents_of_type_imported_yet')
  })));
};
export { DocumentTemplateSectionRow };